module.exports = __webpack_public_path__ + "static/media/Spacing1.a58d6fe5.png";